import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AccountUpdateAlertSubscriptionVariables = Types.Exact<{
  scope: Types.AccountScopeInput;
}>;


export type AccountUpdateAlertSubscription = { __typename?: 'Subscription', account?: { __typename: 'UpdateAccountPayload', account: { __typename?: 'Account', id: string } } | null };


export const AccountUpdateAlert = /*#__PURE__*/ gql`
    subscription AccountUpdateAlert($scope: AccountScopeInput!) {
  account(scope: $scope) {
    ... on UpdateAccountPayload {
      __typename
      account {
        id
      }
    }
  }
}
    ` as unknown as DocumentNode<AccountUpdateAlertSubscription, AccountUpdateAlertSubscriptionVariables>;

          

          export const useAccountUpdateAlertSubscription = (options?:SubscriptionHookOptions<AccountUpdateAlertSubscription, AccountUpdateAlertSubscriptionVariables>) => useSubscription(AccountUpdateAlert, options);

          

          export type AccountUpdateAlertSubscriptionOptions = SubscriptionHookOptions<AccountUpdateAlertSubscription, AccountUpdateAlertSubscriptionVariables>;

          

          export type AccountUpdateAlertSubscriptionResult = ReturnType<typeof useAccountUpdateAlertSubscription>;

          
